<template>
    <section class="current-month">
        {{ humanCurrentMonth }}
    </section>
</template>
<script charset="utf-8">
export default {
    name: "CalendarCurrentMonth",
    computed:{
        humanCurrentMonth(){
            return `${this.monthDict[this.currentDate.getMonth()]} ${this.currentDate.getFullYear()}`;
        },
        currentDate(){
            return this.$store.state.calendarStore.currentDate;
        }
    },
    data(){
        return {
            monthDict: [
                this.$t('com.file.calendar-current-month.january'), 
                this.$t('com.file.calendar-current-month.february'), 
                this.$t('com.file.calendar-current-month.march'), 
                this.$t('com.file.calendar-current-month.april'), 
                this.$t('com.file.calendar-current-month.may'), 
                this.$t('com.file.calendar-current-month.june'), 
                this.$t('com.file.calendar-current-month.july'), 
                this.$t('com.file.calendar-current-month.august'), 
                this.$t('com.file.calendar-current-month.september'), 
                this.$t('com.file.calendar-current-month.october'), 
                this.$t('com.file.calendar-current-month.november'), 
                this.$t('com.file.calendar-current-month.december')
            ]
        }
    }
}
</script>
<style lang="scss">
.current-month{
    font-style: normal;
    font-weight: 600;
    font-size: 2em;
    line-height: 132%;
    color: #00082c;
}
</style>